import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useFormikContext } from 'formik';
import React, { useState, useEffect } from 'react';
import { useObservable } from 'react-use-observable';
import selectAffiliateService from 'v2/services/affiliate/selectAffiliate';

interface IProps {
  handleUncheckAll: () => void;
  selectedQuantity: number;
}

export const Header = ({ handleUncheckAll, selectedQuantity }: IProps) => {
  const [affiliates] = useObservable(() => selectAffiliateService.getAffiliates(), []);
  const [checked, setChecked] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);

  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    const isChecked = affiliates?.length && affiliates?.length === selectedQuantity;
    setChecked(isChecked);

    const isIndeterminate = affiliates?.length > selectedQuantity && !!selectedQuantity;
    setIndeterminate(isIndeterminate);
  }, [affiliates, selectedQuantity]);

  const handleCheckAll = () => setFieldValue('affiliates', affiliates);

  const onClick = affiliates?.length === selectedQuantity ? handleUncheckAll : handleCheckAll;

  return (
    <FormControlLabel
      control={<Checkbox indeterminate={indeterminate} checked={checked} color='primary' onChange={onClick} />}
      label={`Selecione todos os afiliados (${affiliates?.length})`}
    />
  );
};
